import React from 'react';

import { useIntl } from 'react-intl';

import { TextInput } from 'components/ucl';
import { useRoute } from 'hooks/navigation/use-route';

export const PhysicalCardCampaignFields = () => {
  const { formatMessage } = useIntl();
  const { params } = useRoute<{ identifier: string }>();
  const cardNumber = params.identifier;

  if (!cardNumber) {
    return null;
  }

  const cardNumberText = formatMessage({ id: 'cardNumber' });
  return (
    <TextInput
      type="text"
      testID="card-number-input"
      accessibilityLabel={cardNumberText}
      label={cardNumberText}
      value={String(cardNumber)}
      isDisabled
    />
  );
};
